<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.77896 7.04424L8.20737 7.30205L7.77896 7.04424C7.74825 7.09528 7.69814 7.13168 7.6401 7.14512L1.64005 8.53475C0.744185 8.74223 0.391202 9.82861 0.994014 10.523L5.03136 15.174C5.07041 15.219 5.08955 15.2778 5.0844 15.3373L4.55189 21.4731C4.47238 22.3892 5.39651 23.0606 6.24323 22.7019L11.9142 20.2994C11.969 20.2761 12.031 20.2761 12.0858 20.2994L17.7568 22.7019C18.6035 23.0606 19.5276 22.3892 19.4481 21.4731L18.9156 15.3373C18.9104 15.2778 18.9296 15.219 18.9686 15.174L23.006 10.523C23.6088 9.8286 23.2558 8.74223 22.3599 8.53475L16.3599 7.14512C16.3019 7.13168 16.2518 7.09528 16.221 7.04424L13.0453 1.76726C12.5711 0.979361 11.4289 0.979362 10.9547 1.76726L7.77896 7.04424Z"
      fill="#FFBB00" stroke="#CC9600" />
  </svg>
</template>

<script>
export default {
  name: 'ChartStar'
}
</script>

<style lang="scss" scoped>
</style>
